import React from 'react';

class Loading extends React.Component {
  render() {
    return (
      <p>Loading...</p>
    );
  }
}

export default Loading;
